export default "__VITE_ASSET__BIDf1dqT__"